<template>
  <div :id="'acordion'+ 'Favoritos'" class="accordion mb-1 p-1" :style="Skin.menu_live.sport_fondo">
    <div class="accordion-item" :style="Skin.menu_live.sport_fondo+'border:none'">
      <div class="accordion-header">
        <span></span>
        <button class="accordion-button p-0" :style="Skin.menu_live.sport_fondo+ Skin.menu_live.event_text+'box-shadow:none'" type="button" data-bs-toggle="collapse" :data-bs-target="'#d'+ 'Favoritos'" aria-expanded="true" :aria-controls="'d'+ 'Favoritos'">
          &nbsp;&nbsp;&nbsp;{{ language == "es" ? 'Favoritos' : 'Favorites' }} ({{ favorites.length }})
        </button>
      </div>
      <div :id="'d'+ 'Favoritos'" class="accordion-collapse show" aria-labelledby="headingOne" :data-bs-parent="'#acordion'+ 'Favoritos'">
      <div class="accordion-body p-1" style="">
        <eventoEncuentroLive
              v-for="(encuentro,key) in favorites"
              v-bind:encuentro="encuentro"
              v-bind:Skin="Skin"
              v-bind:key="key"
              v-bind:translation="translation"
              v-bind:language="language"
              >
        </eventoEncuentroLive>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import eventoEncuentroLive from './Evento_encuentro_live.vue';
export default{
  name:"FavoritosLive",
  components:{eventoEncuentroLive},
  data(){
    return {
      
    }
  },
  props:['favoritos','Skin','translation','language'],
  computed:{
    favorites(){
        return this.$store.getters['live/getFavorites'];
    },
  }
}
</script>
